<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Add new</h1>
      </v-col>
      <v-col cols="3" sm="2" md="1">
        <v-text-field v-model="newItem.year" label="Year"></v-text-field>
      </v-col>
      <v-col cols="3" sm="2" md="1">
        <v-text-field v-model="newItem.month" label="Month"></v-text-field>
      </v-col>
      <v-col cols="12" md="9">
        <v-file-input v-model="newItem.link" label="Photo"></v-file-input>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="newItem.caption" auto-grow rows="1" label="Image caption"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-btn :loading="loading" color="white" elevation="1" @click="create">Add</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex" cols="12">
        <v-select
          v-model="id"
          :items="photosMembers"
          item-text="caption"
          item-value="id"
          dense
          label="Group Photo to edit"
          filled
          v-on:change="updateItem"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="id">
      <v-col cols="3" sm="2" md="1">
        <v-text-field v-model="item.order" label="Order"></v-text-field>
      </v-col>
      <v-col cols="3" sm="2" md="1">
        <v-text-field v-model="item.year" label="Year"></v-text-field>
      </v-col>
      <v-col cols="3" sm="2" md="1">
        <v-text-field v-model="item.month" label="Month"></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-img class="image" contain :src="item.link"></v-img>
      </v-col>
      <v-col cols="12" md="3">
        <v-file-input v-model="newFile" label="New photo" ></v-file-input>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model="item.caption" auto-grow rows="1" label="Image caption"></v-textarea>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn :loading="loading" color="white" elevation="1" @click="update">Update</v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn :loading="loading" color="red" elevation="1" @click="delet">Delete</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { uploadPhoto } from "@/helpers/storage.js";

export default {
  name: "EditGroupPhotos",
  data() {
    return {
      id: null,
      item: {},
      newFile: null,
      loading: false,
      newItem: {
        caption: null,
        link: [],
        order: null,
        year: "",
        month: ""
      }
    };
  },
  computed: mapState(["loadingPhotosMembers", "photosMembers"]),
  mounted() {
    if (!this.photosMembers.length) this.$store.dispatch("cargarPhotosMembers");
  },
  methods: {
    updateItem() {
      this.item = this.photosMembers.find(val => val.id === this.id);
    },
    update() {
      this.loading = true;
      if(this.newFile!=null){
        this.newFileMet();
      }
      if (this.id)
        this.$store
          .dispatch("updatePhotosMembers", this.item)
          .then(() => ((this.loading = false), alert("Updated!")));
      
    },
    delet() {
      this.loading = true;
      if (this.id)
        this.$store
          .dispatch("deletePhotosMembers", this.item)
          .then(() => (this.loading = false));
      this.loading = true;
    },
    create() {
      this.loading = true;
      let updatedItem = {};
      Object.assign(updatedItem, this.newItem);
      updatedItem.order = this.photosMembers.length+1;
      if (updatedItem.link != null || updatedItem.year || updatedItem.month) {
        delete updatedItem.link;
        this.$store.dispatch("addPhotosMembers", updatedItem).then(id => {
          if(this.newItem.link!=null){
            uploadPhoto("photosMembers", id, this.newItem.link).then(link => {
              updatedItem.link = link;
              updatedItem.id = id;
              this.$store
                .dispatch("updatePhotosMembers", updatedItem)
                .then(() => {
                  this.loading = false;
                  alert("Content created!");
                });
            });
          }
        });
      } else {
        this.loading = false;
        alert("Please fill out all the fields!");
      }
    },
    newFileMet() {
      uploadPhoto("photosMembers", this.item.id, this.newFile).then(link => {
        this.item.link = link;
        this.$store
          .dispatch("updatePhotosMembers", this.item)
          .then(() => ((this.loading = false), alert("Photo updated!")));
      });
    }
  }
};
</script>